import React, { useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

import { useCartRedux, useDashboardRedux, useUserRedux } from '@hooks'
import { DiningMethodSelector, TableSelector } from '@components'
import { DINING_METHOD } from '@common'

const DiningMethodEditModal = ({ isOpen, toggle, currentDiningMethod, currentTableId, hasItems }) => {
    const { setDiningMethod, setTableId } = useUserRedux()
    const { tables } = useDashboardRedux()
    const { clearCart } = useCartRedux()

    const [newDiningMethod, setNewDiningMethod] = useState(currentDiningMethod)
    const [newTableId, setNewTableId] = useState(currentTableId || '')
    const [showWarning, setShowWarning] = useState(false)

    const onDiningMethodChange = value => {
        setNewDiningMethod(value)
        if (value.value === DINING_METHOD.Takeaway) {
            setNewTableId(null)
        } else {
            setNewTableId(currentTableId)
        }
    }

    const onTableChange = value => {
        setNewTableId(value)
    }

    const handleSaveChanges = () => {
        if (newDiningMethod.value !== currentDiningMethod.value && hasItems) {
            setShowWarning(true)
        } else {
            handleConfirmChange()
        }
    }

    const handleConfirmChange = () => {
        if (newDiningMethod.value !== currentDiningMethod.value) {
            setDiningMethod(newDiningMethod)
            clearCart()
        }

        if (!!newTableId?.value && newTableId?.value !== currentTableId?.value) {
            setTableId(newTableId)
        } else {
            setTableId(null)
        }
        setShowWarning(false)
        toggle()
    }

    const handleCancel = () => {
        setShowWarning(false)
        setNewDiningMethod(currentDiningMethod)
        setNewTableId(currentTableId)
        toggle()
    }

    return (
        <>
            <Modal isOpen={isOpen} toggle={handleCancel}>
                <ModalHeader toggle={handleCancel}>Edit Dining Method</ModalHeader>
                <ModalBody>
                    <DiningMethodSelector
                        mode="Dropdown"
                        value={newDiningMethod}
                        onChange={onDiningMethodChange}
                        containerClassName="mt-2"
                    />
                    {newDiningMethod.value === 'DineIn' && (
                        <TableSelector
                            value={newTableId || ''}
                            items={tables.map(table => ({ value: table.id, label: table.name }))}
                            onChange={onTableChange}
                            containerClassName="mt-3"
                        />
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        onClick={handleSaveChanges}
                        disabled={
                            newDiningMethod.value === currentDiningMethod.value && newTableId?.value === currentTableId?.value
                        }
                    >
                        Save Changes
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={showWarning} toggle={() => setShowWarning(false)}>
                <ModalHeader toggle={() => setShowWarning(false)}>Warning</ModalHeader>
                <ModalBody>
                    Changing dining method will clear your cart. All items will need to be re-selected. Do you want to continue?
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setShowWarning(false)}>
                        Cancel
                    </Button>
                    <Button color="danger" onClick={handleConfirmChange}>
                        Continue
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default DiningMethodEditModal
